<template>
  <div v-if="this.showFilters === true" class="fixed top-0 left-0 z-70 w-full grid justify-start unactive_filter"
    id="js_filter_sidebar" style="min-height: var( --app-height);">

    <div class="relative z-10 bg-white w-screen px-s20 pt-s65 pb-s60 m_426:w-s400 m_650:w-s600 filter_content" style="min-height: var( --app-height);">
      <div class="side_element_items overflow-x-hidden overflow-y-scroll h-full">
        <div class="absolute top-0 left-0 w-full bg-white p-s20 flex justify-between items-center">
          <p class="text-t18 font-medium uppercase m_650:text-t20">IZABERI FILTER</p>
          <button type="button" class="text-black js_close_filter">
            <close-icon svgClassName="size-s25 pointer-events-none"></close-icon>
          </button>
        </div>
        
        <div>
          <div class="flex items-start gap-s10 flex-wrap">
            <button type="button" class="p-s10 border border-light-gray flex gap-s10 items-center"
              v-for="(item, index) in this.$parent._data.selectedFilters" @click="removeFromSelectedFilters(index)">
              <p class="font-medium text-t14">{{ item.title }}</p>
              <close-icon svgClassName="size-s15"></close-icon>
            </button>
            <button type="button" class="p-s10 border border-light-gray flex gap-s10 items-center"
              v-for="(item, index) in this.$parent._data.selectedBrends" @click="removeFromSelectedBrends(index)">
              <p class="font-medium text-t14">{{ item.title }}</p>
              <close-icon svgClassName="size-s15"></close-icon>
            </button>
            <button v-if="this.$parent._data.selectedFilters.length > 0 || this.$parent._data.selectedBrends.length > 0"
              type="button" class="p-s10 border border-light-gray  mb-s20" @click="removeFilters()">
              <p class="font-medium text-t14">Resetuj filtere</p>
            </button>
          </div>

          <div class="w-full">
            <Accordion :multiple="true" :activeIndex="accordionIndexes">
              <AccordionTab class="first_lvl">
                <template #header>
                  <div class="w-full p-s10 border-t border-light-gray">
                    <div class="w-full flex items-center justify-between">
                      <span class="text-t16 font-medium uppercase m_650:text-t18">ISTAKNUTO</span>
                      <arrow-icon svgClassName="size-s30 text-gold arrow"></arrow-icon>
                    </div>
                  </div>
                </template>
                <ul class="px-s10 pb-s15">
                  <!--                <li class="mb-s5 last-of-type:mb-0">
                      <button type="button" class="flex items-center gap-s10">
                        <span class="size-s15 border bg-black border-gold"></span>
                        <span>FINAL SALE (134)</span>
                      </button>
                    </li>-->
                  <li class="mb-s5 last-of-type:mb-0" v-for="(item) in stickerAttributes" :key="item.id">
                    <button type="button" @click="addToSelected(item.id, item.title)" class="flex items-center gap-s10"
                      :value="item.id">
                      <span class="size-s15 border border-gold" :class="checkSelectedFilters(item.id)"></span>
                      <span>{{ item.title }} ( {{ item.products_count }} )</span>
                    </button>
                  </li>
                </ul>
              </AccordionTab>

              <AccordionTab v-if="this.tsa > 1" class="first_lvl">
                <template #header>
                  <div class="w-full p-s10 border-t border-light-gray">
                    <div class="w-full flex items-center justify-between">
                      <span class="text-t16 font-medium uppercase m_650:text-t18">POL</span>
                      <arrow-icon svgClassName="size-s30 text-gold arrow"></arrow-icon>
                    </div>
                  </div>
                </template>
                <ul class="px-s10 pb-s15">
                  <li class="mb-s5 last-of-type:mb-0" v-for="(item) in sexAttributes" :key="item.id"
                      @click="checkSexFilters(item.id)"
                  >
                    <button type="button" @click="addToSelected(item.id, item.title)" class="flex items-center gap-s10"
                            :value="item.id">
                      <span class="size-s15 border border-gold" :class="checkSelectedFilters(item.id)"></span>
                      <span>{{ item.title }} ( {{ item.products_count }} )</span>
                    </button>
                  </li>
                </ul>
              </AccordionTab>
              <AccordionTab v-if="this.tca > 1" class="first_lvl">
                <template #header>
                  <div class="w-full p-s10 border-t border-light-gray">
                    <div class="w-full flex items-center justify-between">
                      <span class="text-t16 font-medium uppercase m_650:text-t18">Grupa proizvoda</span>
                      <arrow-icon svgClassName="size-s30 text-gold arrow"></arrow-icon>
                    </div>
                  </div>
                </template>
                <Accordion :multiple="true" :activeIndex="[]">
                  <AccordionTab v-if="clothesAttributes.length > 0" class="second_lvl px-s20">
                    <template #header>
                      <div class="w-full p-s10 border-t border-light-gray">
                        <div class="w-full flex items-center justify-between">
                          <span class="text-t16 font-medium m_650:text-t18">Odeća</span>
                          <arrow-icon svgClassName="size-s30 text-gold arrow"></arrow-icon>
                        </div>
                      </div>
                    </template>
                    <ul class="px-s10 pb-s15">
                      <li class="mb-s5 last-of-type:mb-0" v-for="(item) in clothesAttributes" :key="item.id">
                        <button type="button" @click="addToSelected(item.id, item.title)" class="flex items-center gap-s10"
                                :value="item.id">
                          <span class="size-s15 border border-gold" :class="checkSelectedFilters(item.id)"></span>
                          <span>{{ item.title }} ( {{ item.products_count }} )</span>
                        </button>
                      </li>
                    </ul>
                  </AccordionTab>
                  <AccordionTab v-if="shoesAttributes.length > 0" class="second_lvl px-s20">
                    <template #header>
                      <div class="w-full p-s10 border-t border-light-gray">
                        <div class="w-full flex items-center justify-between">
                          <span class="text-t16 font-medium m_650:text-t18">Obuća</span>
                          <arrow-icon svgClassName="size-s30 text-gold arrow"></arrow-icon>
                        </div>
                      </div>
                    </template>
                    <ul class="px-s10 pb-s15">
                      <li class="mb-s5 last-of-type:mb-0" v-for="(item) in shoesAttributes" :key="item.id">
                        <button type="button" @click="addToSelected(item.id, item.title)" class="flex items-center gap-s10"
                                :value="item.id">
                          <span class="size-s15 border border-gold" :class="checkSelectedFilters(item.id)"></span>
                          <span>{{ item.title }} ( {{ item.products_count }} )</span>
                        </button>
                      </li>
                    </ul>
                  </AccordionTab>
                  <AccordionTab v-if="accessoriesAttributes.length > 0" class="second_lvl px-s20">
                    <template #header>
                      <div class="w-full p-s10 border-t border-light-gray">
                        <div class="w-full flex items-center justify-between">
                          <span class="text-t16 font-medium m_650:text-t18">Aksesoar</span>
                          <arrow-icon svgClassName="size-s30 text-gold arrow"></arrow-icon>
                        </div>
                      </div>
                    </template>
                    <ul class="px-s10 pb-s15">
                      <li class="mb-s5 last-of-type:mb-0" v-for="(item) in accessoriesAttributes" :key="item.id">
                        <button type="button" @click="addToSelected(item.id, item.title)" class="flex items-center gap-s10"
                                :value="item.id">
                          <span class="size-s15 border border-gold" :class="checkSelectedFilters(item.id)"></span>
                          <span>{{ item.title }} ( {{ item.products_count }} )</span>
                        </button>
                      </li>
                    </ul>
                  </AccordionTab>
                </Accordion>
              </AccordionTab>
              <AccordionTab class="first_lvl">
                <template #header>
                  <div class="w-full p-s10 border-t border-light-gray">
                    <div class="w-full flex items-center justify-between">
                      <span class="text-t16 font-medium uppercase m_650:text-t18">BREND</span>
                      <arrow-icon svgClassName="size-s30 text-gold arrow"></arrow-icon>
                    </div>
                  </div>
                </template>
                <ul class="px-s10 pb-s15">
                  <li v-for="(item) in brendAttributes" :key="item.id" class="mb-s5 last-of-type:mb-0">
                    <button type="button" @click="addToBrends(item.id, item.title)" v-if="item.products_count > 0" class="flex items-center gap-s10"
                      :value="item.id">
                      <span class="size-s15 border border-gold" :class="checkSelectedBrends(item.id)"></span>
                      <span>{{ item.title }} ( {{ item.products_count }} )</span>
                    </button>
                  </li>
                </ul>
              </AccordionTab>
              <!-- Colors -->
              <AccordionTab class="first_lvl">
                <template #header>
                  <div class="w-full p-s10 border-t border-light-gray">
                    <div class="w-full flex items-center justify-between">
                      <span class="text-t16 font-medium uppercase m_650:text-t18">BOJA</span>
                      <arrow-icon svgClassName="w-s30 h-s30 text-gold arrow"></arrow-icon>
                    </div>
                  </div>
                </template>
                <ul class="px-s10 pb-s15 grid grid-cols-full gap-s10 m_376:grid-cols-2">
                  <!--                <li><button type="button" class="flex items-center gap-s10">
                      <span class="size-s15 border border-black outline outline-1 outline-white shadow-simple-shadow"
                          style="background-color: #ffffff;"></span>Crna (115)</button></li>
                    <li><button type="button" class="flex items-center gap-s10">
                      <span class="size-s15 outline outline-1 outline-white shadow-simple-shadow"
                          style="background-color: #00ff00;"></span>Svetlo zelena (9)</button></li>
                    <li><button type="button" class="flex items-center gap-s10">
                      <span class="size-s15 border border-black"
                          style="background-color: #ffffff;"></span>Roze (24)</button></li>
                    <li><button type="button" class="flex items-center gap-s10">
                      <span class="size-s15 outline outline-1 outline-white shadow-simple-shadow"
                          style="background-color: #ff0000;"></span>Svetlo braon</button></li>-->
                  <li v-for="(item) in colorAttributes" :key="item.id">
                    <button type="button" @click="addToSelected(item.id, item.title)" class="flex items-center gap-s10">
                      <span class="size-s15 border border-black"
                        v-bind:style="getColorStyle(item.customProperty2)"></span>
                      {{ item.title }} ({{ item.products_count }})
                    </button>
                  </li>
                </ul>
              </AccordionTab>
              <!-- Sizes -->
              <AccordionTab class="first_lvl">
                <template #header>
                  <div class="w-full p-s10 border-t border-light-gray">
                    <div class="w-full flex items-center justify-between">
                      <span class="text-t16 font-medium uppercase m_650:text-t18">VELIČINA</span>
                      <arrow-icon svgClassName="w-s30 h-s30 text-gold arrow"></arrow-icon>
                    </div>
                  </div>
                </template>
                <ul class="px-s10 pb-s15 flex gap-s10 flex-wrap">
                  <!--                <li><button type="button"
                        class="px-s20 py-s10 text-t14 grid place-items-center border border-black cursor-pointer hover:bg-light-gray hover:border-light-gray hover:text-black transition-colors duration-200 bg-black text-white"><span>M/L</span></button>
                    </li>-->
                  <li v-for="(item, index) in sizeAttributes">
                    <button type="button" @click="addToSelected(item.id, item.title)"
                      class="px-s15 py-s10 text-t12 grid place-items-center border border-black cursor-pointer m_1000:hover:bg-black m_1000:hover:text-white m_1000:transition-colors m_1000:duration-200 m_1200:px-s20 m_1200:py-s10 m_1200:text-t14"
                      :class="checkSelectedSizes(item.id)">
                      <span>{{ item.title }}</span>
                    </button>
                  </li>
                </ul>
              </AccordionTab>
            </Accordion>
            <!-- Range -->
<!--            <div class="py-s40 w-10/12 mx-auto">
              <p>Cena:</p>
              <div v-for="(slider, index) in sliders" class="mt-s20 grid gap-s20">
                <vue-slider v-model="slider.range" :min="slider.min" :max="slider.max" :interval="1"
                  :drag-on-click="true"></vue-slider>
                <div class="flex justify-between">
                  <span>{{ slider.range[0] }}</span>
                  <span>{{ slider.range[1] }}</span>
                </div>
              </div>
            </div>-->
          </div>
        </div>
      </div>

      <button
        class="bg-black w-full text-white text-t18 text-center py-s20 cursor-pointer absolute bottom-0 left-0 m_650:text-t20 js_close_filter">PRIKAŽI
        <span>{{ this.$parent._data.products.total }}</span> REZULTATA
      </button>

    </div>

    <div class="bg-black/70 cursor-pointer absolute top-0 left-0 w-full h-full js_close_filter"></div>
  </div>
</template>

<script>
import CloseIcon from "../svg/CloseIcon.vue";
import ArrowIcon from "../svg/ArrowIcon.vue";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';


export default {
  name: "CategoryFilter",
  components: {
    CloseIcon,
    ArrowIcon,
    Accordion,
    AccordionTab,
    VueSlider,
  },

  props: [
    'showFilters',
    'tca',
    'tsa'
  ],

  data() {
    return {
      accordionIndexes: [0],
      properties: this.$parent._data.properties,
      /*sliders: [
        {
          range: [0, Number(this.$parent._data.maxPrice)],
          min: 0,
          max: Number(this.$parent._data.maxPrice),
          maxValueOnStart: Number(this.$parent._data.maxPrice),
        },
      ],*/
      sexAttributesOnFirstLoad:0,
      categoryAttributesOnFirstLoad:0,
      categoriesCount:0,
      url: this.$parent.$attrs.url
    };
  },

  mounted() {
    document.addEventListener('click', this.handleCloseFilterClick);
    document.addEventListener('keydown', this.handleEscapePress);
    document.body.classList.add('no_scroll');
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleCloseFilterClick);
    document.removeEventListener('keydown', this.handleEscapePress);
    document.body.classList.remove('no_scroll');
  },

  computed: {
    brendAttributes() {
      return this.$parent._data.properties['Brend'];
    },
    stickerAttributes() {
      return this.$parent._data.properties['Stiker'];
    },
    sizeAttributes() {
      return this.$parent._data.properties['Veličina'];
    },
    colorAttributes() {
      return this.$parent._data.properties['Boja'];
    },
		sexAttributes() {
			return this.$parent._data.properties['Pol'];
		},
    shoesAttributes()
    {
      if (this.$parent._data.properties['Kategorija'].hasOwnProperty('Obuća')) {
        return this.$parent._data.properties['Kategorija']['Obuća'];
      } else {
        return [];
      }
    },
    clothesAttributes() {

      if (this.$parent._data.properties['Kategorija'].hasOwnProperty('Odeća')) {
        return this.$parent._data.properties['Kategorija']['Odeća'];
      } else {
        return [];
      }

    },
    accessoriesAttributes() {

      if (this.$parent._data.properties['Kategorija'].hasOwnProperty('Aksesoar')) {
        return this.$parent._data.properties['Kategorija']['Aksesoar'];
      } else {
        return [];
      }

    },

  },
  methods: {
    getColorStyle(color) {
      return {
        backgroundColor: color
      }
    },
    async addToBrends(id, title) {

      let selectedBrendsIds = this.$parent._data.selectedBrends.map(item => item.id).includes(id);

      // If there is already selected brend with that id do nothing.
      if (selectedBrendsIds === false) {
        this.$parent._data.selectedBrends.push({ id: id, title: title });
        return this.updateData();
      }
    },
    async addToSelected(id, title) {

      let selectedFiltersIds = this.$parent._data.selectedFilters.map(item => item.id).includes(id);

      // If there is already selected filter with that id do nothing.
      if (selectedFiltersIds === false) {
        this.$parent._data.selectedFilters.push({ id: id, title: title });
        return this.updateData();
      }
    },
    removeFromSelectedFilters(index) {
      this.$parent._data.selectedFilters.splice(index, 1);

      return this.updateData();
    },
    removeFromSelectedBrends(index) {
      this.$parent._data.selectedBrends.splice(index, 1);

      return this.updateData();
    },
    async updateData() {
      let selectedFiltersIds = this.$parent._data.selectedFilters.map(item => item.id);
      let selectedFiltersForUrl = selectedFiltersIds.join('&filters[]=');
      let selectedBrendsIds = this.$parent._data.selectedBrends.map(item => item.id);
      let selectedBrendsForUrl = selectedBrendsIds.join('&brends[]=');

      //let minPrice = this.sliders[0].range[0];
      //let maxPrice = this.sliders[0].range[1];

      let sortType = this.$parent._data.sortType;
      let sortValue = this.$parent._data.sortValue;

      this.$parent._data.loader = true;

      if (selectedFiltersForUrl.length > 0 || selectedBrendsForUrl.length > 0) {
        var realPath = (selectedBrendsIds.length > 0 ? `brends[]=${selectedBrendsForUrl}` : "") +
          (selectedFiltersIds.length > 0 ? `&filters[]=${selectedFiltersForUrl}` : "") +
          //`&minPrice[]=${minPrice}` + `&maxPrice[]=${maxPrice}` +
          `&sortType=${sortType}` + `&sortValue=${sortValue}`;

        await this.$router.push(`?${realPath}`);
      } else {
        await this.$router.push(``);
      }

      let result = await axios.get(this.url, {
        params: {
          sortType: sortType,
          sortValue: sortValue,
          filters: selectedFiltersIds,
          brends: selectedBrendsIds,
          //minPrice: minPrice,
          //maxPrice: maxPrice
        }
      })
        .then(function (response) {

          const products = response.data.products;
          const properties = response.data.properties;
          //const maxPrice = response.data.maxPrice

          return [products, properties];
        })
        .catch(function (error) {
          console.log(error);
        });

      this.$parent._data.products = result[0];
      if (result[1] !== null) {
        this.$parent._data.properties = result[1];
        //this.sliders[0].max = Number(result[2]);
        //this.sliders[0].range = [0, Number(result[2])];
        /*range: [0, Number(this.$parent._data.maxPrice)],
          min: 0,
          max: Number(this.$parent._data.maxPrice),*/
      }
			this.$parent._data.loader = false;

    },
    handleCloseFilterClick(event) {
      if (event.target.classList.contains('js_close_filter')) {
        this.hideSidebar();
      }
    },
    handleEscapePress(event) {
      if (event.key === 'Escape') {
        this.hideSidebar();
      }
    },
    hideSidebar() {
      const toCloseFilter = document.getElementById('js_filter_sidebar');
      toCloseFilter.style.display = 'none';
      this.$parent._data.showFilters = false;
      document.body.classList.remove('no_scroll');
    },

    removeFilters() {
      // Remove all selected filters
      this.$parent._data.selectedFilters = [];
      this.$parent._data.selectedBrends = [];

      // Return to values from the start.
      //this.sliders[0].max = this.sliders[0].maxValueOnStart;
      //this.sliders[0].range = [0, this.sliders[0].maxValueOnStart];

      return this.updateData();
    },

    checkSelectedBrends(index) {

      let selectedBrendsIds = this.$parent._data.selectedBrends.map(item => item.id).includes(index);

      if (selectedBrendsIds === true) {
        return 'bg-black'
      }
    },
    checkSelectedFilters(index) {

      let selectedFiltersIds = this.$parent._data.selectedFilters.map(item => item.id).includes(index);

      if (selectedFiltersIds === true) {
        return 'bg-black'
      }
    },
    // checkSelectedColors(index) {

    //   let selectedFiltersIds = this.$parent._data.selectedFilters.map(item => item.id).includes(index);

    //   if (selectedFiltersIds === true) {
    //     return 'outline outline-1 outline-white shadow-simple-shadow'
    //   }
    // },
    checkSelectedSizes(index) {
      let selectedFiltersIds = this.$parent._data.selectedFilters.map(item => item.id).includes(index);

      if (selectedFiltersIds === true) {
        return 'bg-black text-white'
      }
    }
  },
}
</script>

<style scoped>
.unactive_filter .filter_content{animation:sideCart ease-in-out 500ms;animation-iteration-count:1;animation-fill-mode:forwards}@keyframes sideCart{0%{transform:translatex(-100%)}100%{transform:translatex(0%)}}.side_element_items{max-height:calc(var( --app-height) - 128px)}.side_element_items{scrollbar-width:auto;scrollbar-color:#D9D9D9 #fff}.side_element_items::-webkit-scrollbar{width:12px}.side_element_items::-webkit-scrollbar-track{background:#fff}.side_element_items::-webkit-scrollbar-thumb{background-color:#D9D9D9;border-radius:0;border-left:1px solid #fff;border-right:1px solid #fff}:deep(.p-accordion-tab .arrow){transition:transform 300ms ease}:deep(.p-accordion-tab.p-accordion-tab-active.first_lvl>.p-accordion-header .arrow){transform:rotate(180deg)}:deep(.p-accordion-tab.p-accordion-tab-active.second_lvl>.p-accordion-header .arrow){transform:rotate(180deg)}:deep(.vue-slider-rail){border-radius:0;background-color:#D9D9D9}:deep(.vue-slider-process){background-color:#C49A6C}:deep(.vue-slider-dot-handle){background-color:#000;box-shadow:none}:deep(.vue-slider-dot-tooltip-inner){border-radius:0;border-color:#C49A6C;background-color:#C49A6C}
</style>